import React from 'react'
import { CargoUnit } from '../../../../../common/types/interfaces'
import classes from './CargoUnitItem.module.sass'

type Props = {
  el: CargoUnit
}

export const CargoUnitItem = ({ el }: Props) => {
  return (
    <div className={classes.Container} key={el.id}>
      <div className={classes.Field}>
        <span className={classes.Label}>Длина, см</span>
        {new Intl.NumberFormat('ru-RU').format(Number(el.length))}
      </div>
      <div className={classes.Field}>
        <span className={classes.Label}>Ширина, см</span>
        {new Intl.NumberFormat('ru-RU').format(Number(el.width))}
      </div>
      <div className={classes.Field}>
        <span className={classes.Label}>Высота, см</span>
        {new Intl.NumberFormat('ru-RU').format(Number(el.height))}
      </div>
      <div className={classes.Field}>
        <span className={classes.Label}>Вес, кг</span>
        {new Intl.NumberFormat('ru-RU').format(Number(el.weight))}
      </div>
      <div className={classes.Field}>
        <span className={classes.Label}>Мест, шт</span>
        {new Intl.NumberFormat('ru-RU').format(Number(el.count))}
      </div>
    </div>
  )
}
